export const API_URL = "https://api.concretedecor.net/api/";
export default API_URL;

// export const PUSHER_KEY = "df8d0089ed4fd46080f2";
export const MIX_STRIPE_KEY = "pk_live_Ri8INbroRGRTob2wZLaPcP6W00MQuBRTFV";
